"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombustionGfx = void 0;
const three_10 = require("three");
const OrbitControls_2 = require("three/examples/jsm/controls/OrbitControls");
const GLTFLoader_2 = require("three/examples/jsm/loaders/GLTFLoader");
const _ombustion_Shader_1 = require("./shaders/\u0421ombustion.Shader");
class CombustionGfx {
    constructor() {
        // this.init();
        this.delta = 0;
        this.elapsedTime = 0;
        this.timeCoef = 1;
        this.timeStop = false;
        this.previousRenderScene = this.renderScene;
        this.sizes = {
            width: 0,
            height: 0
        };
        this.tick = () => {
            window.requestAnimationFrame(this.tick);
            const button = document.getElementById('timeToggleBtn');
            if (this.renderScene !== this.previousRenderScene) {
                this.previousRenderScene = this.renderScene;
                if (button) {
                    button.style.display = this.renderScene ? 'block' : 'none';
                }
            }
            //
            if (this.sizes.width !== window.innerWidth || this.sizes.height !== window.innerHeight) {
                this.resize();
            }
            //
            if (this.timeStop) {
                this.delta = this.clock.getDelta() * 1000;
                this.elapsedTime += this.delta;
            }
            else {
                this.clock.running = false;
            }
            if (this.potatoMaterial)
                this.potatoMaterial.uniforms.uTime.value = (this.elapsedTime % 2800 + 400) / 4000; //this.elapsedTime / 10 / 1000;
            //
            this.mapControls.update();
            this.renderer.render(this.scene, this.camera);
        };
    }
    ;
    init() {
        // Canvas
        this.canvas = document.querySelector('canvas.webglViewCombustion');
        // Scene
        this.scene = new three_10.Scene();
        this.scene.background = new three_10.Color('#78614c');
        // Camera
        this.camera = new three_10.PerspectiveCamera(45, this.sizes.width / this.sizes.height, 0.1, 1000);
        this.camera.position.set(0, 10, 10);
        this.scene.add(this.camera);
        // Controls
        this.mapControls = new OrbitControls_2.MapControls(this.camera, this.canvas);
        this.mapControls.enableDamping = true;
        // Renderer
        this.renderer = new three_10.WebGLRenderer({ canvas: this.canvas });
        this.renderer.setSize(this.sizes.width, this.sizes.height);
        // Plane
        let planeGeometry = new three_10.PlaneBufferGeometry(3000, 3000, 1, 1);
        let planeMaterial = new three_10.MeshBasicMaterial({ color: '#453322' });
        let plane = new three_10.Mesh(planeGeometry, planeMaterial);
        plane.rotation.x -= Math.PI / 2;
        this.scene.add(plane);
        /// Light
        const light = new three_10.PointLight(0xe9f7ec, 1, 500);
        light.position.set(1, 3, 5);
        this.scene.add(light);
        this.clock = new three_10.Clock();
        this.potatoLoading();
        if (this.potato) {
            this.potato.rotation.z += Math.PI;
            this.potato.position.y = 1.35;
        }
        this.debug();
        //
        this.tick();
    }
    ;
    debug() {
        let isRunning = false;
        const buttonEl = document.createElement('div');
        buttonEl.id = 'timeToggleBtn';
        buttonEl.textContent = 'RUN';
        buttonEl.style.position = 'absolute';
        buttonEl.style.top = '75%';
        buttonEl.style.zIndex = '200';
        buttonEl.style.width = '150px';
        buttonEl.style.height = '80px';
        buttonEl.style.backgroundColor = '#2c3e50';
        buttonEl.style.color = 'white';
        buttonEl.style.borderRadius = '12px';
        buttonEl.style.fontFamily = 'sans-serif';
        buttonEl.style.fontSize = '20px';
        buttonEl.style.cursor = 'pointer';
        buttonEl.style.textAlign = 'center';
        buttonEl.style.lineHeight = '80px';
        buttonEl.style.opacity = '0.7';
        buttonEl.style.left = '50%';
        buttonEl.style.transform = 'translateX(-50%)';
        document.body.appendChild(buttonEl);
        buttonEl.addEventListener('mousedown', () => {
            buttonEl.style.opacity = '1';
            buttonEl.style.transform = 'translateX(-50%) scale(0.95)';
            buttonEl.textContent = isRunning ? 'STOP' : 'RUN';
        });
        buttonEl.addEventListener('mouseup', () => {
            buttonEl.style.opacity = '0.7';
            buttonEl.style.transform = 'translateX(-50%) scale(1)';
            buttonEl.textContent = isRunning ? 'STOP' : 'RUN';
        });
        document.addEventListener('mouseup', () => {
            buttonEl.style.opacity = '0.7';
            buttonEl.style.transform = 'translateX(-50%) scale(1)';
            buttonEl.textContent = isRunning ? 'STOP' : 'RUN';
        });
        buttonEl.addEventListener('click', () => {
            isRunning = !isRunning;
            buttonEl.textContent = isRunning ? 'STOP' : 'RUN';
        });
        const button = document.getElementById('timeToggleBtn');
        if (!button)
            return;
        button.addEventListener('click', () => {
            this.timeStop = !this.timeStop;
            if (this.timeStop) {
                this.timeCoef = this.elapsedTime;
                this.potatoMaterial.uniforms.uTime.value = this.timeCoef / 10 / 100;
            }
            else {
                this.timeCoef = 1;
            }
        });
        button.style.display = this.renderScene ? 'block' : 'none';
    }
    ;
    resize() {
        this.sizes.width = window.innerWidth;
        this.sizes.height = window.innerHeight;
        this.camera.aspect = this.sizes.width / this.sizes.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.sizes.width, this.sizes.height);
        this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    }
    ;
    potatoLoading() {
        // Loading potato_character
        this.loader = new GLTFLoader_2.GLTFLoader();
        this.loader.load('resources/models/potato_character/scene.gltf', (gltf) => {
            this.potato = gltf.scene.children[0];
            this.potato.traverse((item) => {
                if (item instanceof three_10.Mesh && item.material instanceof three_10.Material) {
                    // @ts-ignore
                    this.potatoMaterial = new _ombustion_Shader_1.СombustionMaterial({ color: 0xffffff });
                    // @ts-ignore
                    this.potatoMaterial.uniforms.tDiffuse.value = item.material.map;
                    // @ts-ignore
                    item.material = this.potatoMaterial;
                }
                this.potato.rotation.z += Math.PI;
                this.potato.position.y = 1.35;
                this.scene.add(this.potato);
            });
        });
    }
    ;
}
exports.CombustionGfx = CombustionGfx;
;
exports.default = new CombustionGfx();
